module.exports = __webpack_public_path__ + "static/media/Medalha-Ouro.755bc22d.svg";